import { useDispatch, useSelector } from "react-redux";
import MySubscriptionServiceCard from "./MySubscriptionServiceCard";
import { useEffect, useState } from "react";
import {
  cancelSubscriptionReq,
  cancelSubscriptionReqClear,
  getSubscription,
  getSubscriptionClear,
} from "../../redux/orders/actions";
import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import MySubscriptionServiceShimmerCard from "./MySubscriptionServiceShimmerCard";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import { Tab, Tabs } from "react-bootstrap";

const MySubscriptionSection = ({
  isLoading, setIsLoading
}) => {

  const dispatch = useDispatch();

  const subscriptionData = useSelector(state => state.orders.subscription);
  const cancelSubscriptionData = useSelector(state => state.orders.cancelSubscription);

  const [subscriptionList, setSubscriptionList] = useState([])
  const [subscriptionPastList, setSubscriptionPastList] = useState([])
  const [confirmModal, setConfirmModal] = useState(false)
  const [showModalMsg, setShowModalMsg] = useState('')
  const [activeTab, setActiveTab] = useState('ongoing');

  useEffect(() => {
    console.log('SUBSCRIPTION');
    dispatch(
      getSubscription({
        module: 'getSubscription',
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
        }
      })
    )
  }, [dispatch])

  useEffect(() => {
    if (confirmModal) {
      setTimeout(() => {
        setConfirmModal(false)
        setShowModalMsg('')
      }, [5000])
    }
  }, [confirmModal])

  useEffect(() => {
    if (!_.isEmpty(subscriptionData)) {
      if (subscriptionData.status === 'success') {
        const data = subscriptionData.payload.payload;
        if (!_.isEmpty(data)) {
          console.log(data)
          setSubscriptionList(_.filter(data, (d) => {
            if (_.toNumber(d.is_active) == 1) return d
          }))
          setSubscriptionPastList(_.filter(data, (d) => {
            if (_.toNumber(d.is_active) != 1) return d
          }))
        }
      }
      setIsLoading(false)
      dispatch(getSubscriptionClear())
    }
  }, [subscriptionData])

  useEffect(() => {
    if (!_.isEmpty(cancelSubscriptionData)) {
      if (cancelSubscriptionData.status === 'success') {
        setShowModalMsg(cancelSubscriptionData?.payload?.message);
      } else {
        let errorMsg = cancelSubscriptionData.error?.message;
        setShowModalMsg(errorMsg)
      }
      window.scrollTo(0, 0);
      setConfirmModal(true)
      setIsLoading(false)
      dispatch(cancelSubscriptionReqClear());
    }
  }, [cancelSubscriptionData])

  const submitCancelRequest = (order_id, subscription_id) => {
    dispatch(
      cancelSubscriptionReq({
        module: "cancelSubscription",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          order_id,
          subscription_id
        }
      })
    )
  }

  const renderAlertCard = () => {
    return (
      <div
        className={`alert-card d-flex justify-content-center ${confirmModal ? "" : "d-none"
          }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <g
                id="Group_5699"
                data-name="Group 5699"
                transform="translate(0.498 0.498)"
              >
                <circle
                  id="Ellipse_222"
                  data-name="Ellipse 222"
                  cx="9"
                  cy="9"
                  r="9"
                  transform="translate(-0.498 -0.498)"
                  fill="#A9C23C"
                />
                <path
                  id="Icon_material-done"
                  data-name="Icon material-done"
                  d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z"
                  transform="translate(-3.013 -6.071)"
                  fill="#fff"
                  stroke="#fff"
                  strokeWidth="2"
                />
              </g>
            </svg>
            <p className="m-0">{showModalMsg}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setConfirmModal(false);
                setShowModalMsg("");
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <section className="my_order" id="my-subscription-page">
        <div className="order-wrapper">
          <div className="container position-relative">
            {renderAlertCard()}
            <div className="row">
              <div className="col-md-12 mt-2">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="lable-heading_search mb-0">Purchased Subscription</h3>
                  <div class="info-subs">Please contact support@xsel.app to cancel your Subscription.</div>
                </div>
                <div className="col-md-12 mt-5 rows my_courses">
                  <Tabs
                    onSelect={(k) => setActiveTab(k)}
                    activeKey={activeTab}
                    defaultActiveKey="ongoing"
                    className="mb-4">
                    <Tab eventKey="ongoing" title="Ongoing Subscriptions">
                      <div className="order-total_wrapper">
                        {
                          !isLoading ?
                            !_.isEmpty(subscriptionList) ?
                              subscriptionList.map((subscription, i) => {
                                return (
                                  <MySubscriptionServiceCard
                                    submitCancelRequest={submitCancelRequest}
                                    subscription={subscription}
                                    key={i}
                                    isPast={false}
                                  />
                                )
                              })
                              :
                              <div className="not-found mt-3">
                                <div className="interboxes">
                                <NotFoundImage />
                                  {/* <img src="/images/telescope.svg" alt="Not Found" /> */}
                                  <p>No item found.</p>
                                </div>
                              </div>
                            :
                            [1, 2, 3].map((m, i) => {
                              return (
                                <MySubscriptionServiceShimmerCard
                                  key={`sub-${i + 1}`}
                                />
                              )
                            })
                        }
                      </div>
                    </Tab>
                    <Tab eventKey="past" title="Past Subscriptions">
                      <div className="order-total_wrapper">
                        {
                          !isLoading ?
                            !_.isEmpty(subscriptionPastList) ?
                              subscriptionPastList.map((subscription, i) => {
                                return (
                                  <MySubscriptionServiceCard
                                    submitCancelRequest={submitCancelRequest}
                                    subscription={subscription}
                                    key={i}
                                    isPast={true}
                                  />
                                )
                              })
                              :
                              <div className="not-found mt-3">
                                <div className="interboxes">
                                <NotFoundImage />
                                  <p>No item found.</p>
                                </div>
                              </div>
                            :
                            [1, 2, 3].map((m, i) => {
                              return (
                                <MySubscriptionServiceShimmerCard
                                  key={`sub-${i + 1}`}
                                />
                              )
                            })
                        }
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default MySubscriptionSection;
